var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { IRMSErrorEnum } from "./action-interface/RmsDetailsActions";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
var TOCJourneyPresenter = /** @class */ (function () {
    function TOCJourneyPresenter(usecase, actions, accounDetails, useCasesStream) {
        this.usecase = usecase;
        this.actions = actions;
        this.accounDetails = accounDetails;
        this.useCasesStream = useCasesStream;
        this.tocOpen = localStorage.getItem("AuthToSellSymbol") ? true : false;
    }
    TOCJourneyPresenter.prototype.mfPauseResume = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.mfPauseResumeOrder.execute({
                            onSuccess: function (data) { return resolve(data); },
                            onError: function (error) { return reject(error); },
                        }, req);
                    })];
            });
        });
    };
    TOCJourneyPresenter.prototype.mfCancelOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfCancelOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getModifyPreApplyIpo = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getModifyPreApplyIpo.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getIpoPreApply = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getIpoPreApply.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getModifyIpo = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getModifyIpo.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getIpoCancel = function (req) {
        var _this = this;
        this.actions.IpoCancel.hideError();
        this.actions.IpoCancel.startLoader();
        this.usecase.getIpoCancel.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.IpoCancel.getIpoCancel(data);
                    _this.actions.IpoCancel.stopLoader();
                }
            },
            onError: function (error) {
                _this.actions.IpoCancel.setError({ isOpen: true, error: error });
                _this.actions.IpoCancel.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.emptyIpoCancel = function () {
        this.actions.IpoCancel.getIpoCancel({});
        this.actions.IpoOtpRegister.setError({ isOpen: false, error: undefined });
        this.actions.IpoCancel.hideError();
    };
    TOCJourneyPresenter.prototype.getIpoOtpRegister = function (req) {
        var _this = this;
        this.actions.IpoOtpRegister.hideError();
        this.actions.IpoOtpRegister.startLoader();
        this.usecase.getIpoOtpRegister.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.IpoOtpRegister.getIpoOtpRegister(data);
                    _this.actions.IpoOtpRegister.stopLoader();
                }
            },
            onError: function (error) {
                _this.actions.IpoOtpRegister.setError({ isOpen: true, error: error });
                _this.actions.IpoOtpRegister.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.flushIpoRegisteredOtp = function () {
        this.actions.IpoOtpRegister.flushOtpData();
    };
    TOCJourneyPresenter.prototype.getIpoOtpValidate = function (req) {
        var _this = this;
        this.actions.IpoOtpValidate.hideError();
        this.actions.IpoOtpValidate.startLoader();
        this.usecase.getIpoOtpValidate.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.IpoOtpValidate.getIpoOtpValidate(data);
                    _this.actions.IpoOtpValidate.stopLoader();
                }
            },
            onError: function (error) {
                _this.actions.IpoOtpValidate.setError({ isOpen: true, error: error });
                _this.actions.IpoOtpValidate.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.flushIpoOtpValidateData = function () {
        this.actions.IpoOtpValidate.flushIpoOtpValidateData();
    };
    TOCJourneyPresenter.prototype.getIpoBankMaster = function () {
        var _this = this;
        this.actions.IpoBankMaster.hideError();
        this.actions.IpoBankMaster.startLoader();
        this.usecase.getIpoBankMaster.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.IpoBankMaster.getIpoBankMaster(data);
                    _this.actions.IpoBankMaster.stopLoader();
                }
            },
            onError: function (error) {
                _this.actions.IpoBankMaster.setError({ isOpen: true, error: error });
                _this.actions.IpoBankMaster.stopLoader();
            },
        }, null);
    };
    TOCJourneyPresenter.prototype.getNcdIpoBankNames = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getNcdIpoBankNames.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getIpoOtpLeads = function (req) {
        var _this = this;
        this.actions.IpoOtpLeads.hideError();
        this.actions.IpoOtpLeads.startLoader();
        this.usecase.getIpoOtpLeads.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.IpoOtpLeads.getIpoOtpLeads(data);
                    _this.actions.IpoOtpLeads.stopLoader();
                }
            },
            onError: function (error) {
                _this.actions.IpoOtpLeads.setError({ isOpen: true, error: error });
                _this.actions.IpoOtpLeads.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.mfPurchaseOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfPurchaseOrder.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getSipStartDate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfSipStartDate.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getSipFrequency = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfSipFrequency.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getMFPurchase = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfPurchase.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getMFHoldingDetail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfHoldingDetail.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getMFSchemeHoldingDetail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfSchemeHoldingDetail.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getNfoPurchase = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.nfoPurchase.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.CancelPlaceOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.cancelPlaceOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.CoCancelPlaceOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.coCancelPlaceOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.CancelEsipOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.cancelEsipOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.modifyOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.modifyOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.coModifyOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.coModifyOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.mfParticularHolding = function (req) {
        var _this = this;
        // this.actions.mfParticularHolding.hideError();
        // this.actions.mfParticularHolding.startLoader();
        return new Promise(function (resolve, reject) {
            _this.usecase.MFParticularHolding.execute({
                onSuccess: function (data) {
                    // if (data) {
                    //   this.actions.mfParticularHolding.getMfParticularHolding(data);
                    //   this.actions.mfParticularHolding.stopLoader();
                    // }
                    resolve(data);
                },
                onError: function (error) {
                    // this.actions.mfParticularHolding.setError({ isOpen: true, error });
                    // this.actions.mfParticularHolding.stopLoader();
                    reject(error);
                },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getMultiQuoteData = function (multiQuote) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.actions.multiQuoteActions.hideError();
            _this.actions.multiQuoteActions.startMultiQuoteloader();
            _this.usecase.multiQuote.execute({
                onSuccess: function (data) {
                    var _a;
                    if (data) {
                        _this.actions.multiQuoteActions.getMultiQuoteData(data);
                        _this.actions.multiQuoteActions.stopMultiQuoteLoader();
                        if (!(multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.isModifyOrder) &&
                            _this.accounDetails.isUserLoggedIn()) {
                            _this.AMOStatus({
                                exchange: (_a = data === null || data === void 0 ? void 0 : data.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange,
                            });
                        }
                        resolve(data);
                    }
                },
                onError: function (error) {
                    _this.actions.multiQuoteActions.setError({ isOpen: true, error: error });
                    _this.actions.multiQuoteActions.stopMultiQuoteLoader();
                    reject(error);
                },
            }, multiQuote);
        });
    };
    TOCJourneyPresenter.prototype.flushMultiQuoteData = function () {
        this.actions.multiQuoteActions.hideError();
        this.actions.multiQuoteActions.getMultiQuoteData({});
    };
    TOCJourneyPresenter.prototype.getMultiQuote = function (multiQuote) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.multiQuote.execute({
                            onSuccess: function (data) {
                                return resolve(data.quotesDetailsEntity);
                            },
                            onError: function (error) { return reject(error); },
                        }, multiQuote);
                    })];
            });
        });
    };
    TOCJourneyPresenter.prototype.clrNormalTrade = function () {
        this.actions.placeNormalTrade.placeNormalTrade({
            message: "",
            success: false,
            orderID: "",
        });
    };
    TOCJourneyPresenter.prototype.placeNormalTrade = function (req) {
        var _this = this;
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.placeNormalTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeNormalTrade.placeNormalTrade(data);
                _this.actions.placeNormalTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeNormalTrade.setError({ isOpen: true, error: error });
                _this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeOfsTrade = function (req) {
        var _this = this;
        this.actions.placeOfsTrade.hideError();
        this.actions.placeOfsTrade.loader();
        this.usecase.placeOfsTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeOfsTrade.placeNormalTrade(data);
                _this.actions.placeOfsTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeOfsTrade.setError({ isOpen: true, error: error });
                _this.actions.placeOfsTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeOfsModifyTrade = function (req) {
        var _this = this;
        this.actions.placeOfsTrade.hideError();
        this.actions.placeOfsTrade.loader();
        this.usecase.modifyOfsTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeOfsTrade.placeNormalTrade(data);
                _this.actions.placeOfsTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeOfsTrade.setError({ isOpen: true, error: error });
                _this.actions.placeOfsTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeTradeComm = function (req) {
        var _this = this;
        this.actions.placeTradeComm.hideError();
        this.actions.placeTradeComm.loader();
        this.usecase.placeTradeComm.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeTradeComm.placeNormalTrade(data);
                _this.actions.placeTradeComm.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeTradeComm.setError({ isOpen: true, error: error });
                _this.actions.placeTradeComm.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeAMOTrade = function (req) {
        var _this = this;
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.amoPlaceTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeNormalTrade.placeNormalTrade(data);
                _this.actions.placeNormalTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeNormalTrade.setError({ isOpen: true, error: error });
                _this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.flushPlaceOrderError = function () {
        var _this = this;
        return new Promise(function (res, err) {
            _this.actions.placeNormalTrade.hideError();
            _this.actions.orderDetails.hideError();
            res();
        });
    };
    TOCJourneyPresenter.prototype.flushPlaceOrderData = function () {
        var _this = this;
        return new Promise(function (res, rej) {
            _this.actions.placeNormalTrade.clearData();
            _this.actions.orderDetails.clearData();
            res();
        });
    };
    TOCJourneyPresenter.prototype.placeAMOTradeComm = function (req) {
        var _this = this;
        this.actions.placeTradeComm.hideError();
        this.actions.placeTradeComm.loader();
        this.usecase.amoPlaceTradeComm.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeTradeComm.placeNormalTrade(data);
                _this.actions.placeTradeComm.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeTradeComm.setError({ isOpen: true, error: error });
                _this.actions.placeTradeComm.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeBracketTrade = function (req) {
        var _this = this;
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.bracketTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeNormalTrade.placeNormalTrade(data);
                _this.actions.placeNormalTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeNormalTrade.setError({ isOpen: true, error: error });
                _this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.placeEsipTrade = function (req) {
        var _this = this;
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.esipTrade.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.placeNormalTrade.placeNormalTrade(data);
                _this.actions.placeNormalTrade.stopLoader();
            },
            onError: function (error) {
                _this.actions.placeNormalTrade.setError({ isOpen: true, error: error });
                _this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.orderDetails = function (req) {
        var _this = this;
        this.actions.orderDetails.hideError();
        this.actions.orderDetails.loader();
        this.usecase.orderDetailsUseCase.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.orderDetails.orderDetails(data);
                _this.actions.orderDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.orderDetails.setError({ isOpen: true, error: error });
                _this.actions.orderDetails.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.checkMargin = function (req) {
        var _this = this;
        this.actions.checkMargin.hideError();
        this.actions.checkMargin.loader();
        this.usecase.checkMargin.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.checkMargin.getCheckMargin(data);
                _this.actions.checkMargin.stopLoader();
            },
            onError: function (error) {
                _this.actions.checkMargin.setError({ isOpen: true, error: error });
                _this.actions.checkMargin.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.flushMarginData = function () {
        this.actions.checkMargin.hideError();
        this.actions.checkMargin.removeMarginData();
    };
    TOCJourneyPresenter.prototype.flushRmsHoldingData = function () {
        this.actions.rmsDetails.hideError(IRMSErrorEnum.RMS_HOLDING_ERROR);
        this.actions.rmsDetails.updateRmsHolding({});
    };
    TOCJourneyPresenter.prototype.brokerCharge = function (req) {
        var _this = this;
        this.actions.brokerCharges.hideError();
        this.actions.brokerCharges.loader();
        this.usecase.brokerCharge.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.brokerCharges.getBrokerCharges(data);
                _this.actions.brokerCharges.stopLoader();
            },
            onError: function (error) {
                _this.actions.brokerCharges.setError({ isOpen: true, error: error });
                _this.actions.brokerCharges.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.brokerChargeComm = function (req) {
        var _this = this;
        this.actions.brokerChargesComm.hideError();
        this.actions.brokerChargesComm.loader();
        this.usecase.brokerChargeComm.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.brokerChargesComm.getBrokerCharges(data);
                _this.actions.brokerChargesComm.stopLoader();
            },
            onError: function (error) {
                _this.actions.brokerChargesComm.setError({ isOpen: true, error: error });
                _this.actions.brokerChargesComm.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.AMOStatus = function (subReq) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this.accounDetails.getAccTyp()];
                    case 1:
                        req = (_a.accType = _b.sent(),
                            _a.exchange = subReq.exchange,
                            _a);
                        this.actions.amoStatus.hideError();
                        this.actions.amoStatus.loader();
                        this.usecase.amoStatus.execute({
                            onSuccess: function (data) {
                                _this.actions.amoStatus.AMOStatus(data);
                                _this.actions.amoStatus.stopLoader();
                            },
                            onError: function (error) {
                                _this.actions.amoStatus.setError({ isOpen: true, error: error });
                                _this.actions.amoStatus.stopLoader();
                            },
                        }, req);
                        return [2 /*return*/];
                }
            });
        });
    };
    TOCJourneyPresenter.prototype.getTpinApiDetails = function (tpinReq) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = null;
                        return [4 /*yield*/, this.usecase.tpinHolding.execute({
                                onSuccess: function (data) {
                                    response = data;
                                },
                                onError: function (error) {
                                    // response.amoFlag = false;
                                },
                            }, tpinReq)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    TOCJourneyPresenter.prototype.getRmsSublimits = function (req) {
        var _this = this;
        this.actions.rmsDetails.hideError(IRMSErrorEnum.ERROR_DATA);
        this.actions.rmsDetails.startRmsSublimitsLoader();
        this.usecase.rmsSubLimits.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.rmsDetails.getRmsSublimitsData(data);
                _this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
            onError: function (error) {
                _this.actions.rmsDetails.setError({ isOpen: true, error: error }, IRMSErrorEnum.ERROR_DATA);
                _this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.getLimits = function (req) {
        var _this = this;
        this.actions.limits.hideError(IRMSErrorEnum.ERROR_DATA);
        this.actions.limits.loader();
        this.usecase.limitsDetails.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.limits.getLimits(data);
                _this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
            onError: function (error) {
                _this.actions.rmsDetails.setError({ isOpen: true, error: error }, IRMSErrorEnum.ERROR_DATA);
                _this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.getRmsHoldingDetails = function (req) {
        var _this = this;
        this.actions.rmsDetails.hideError(IRMSErrorEnum.RMS_HOLDING_ERROR);
        this.actions.rmsDetails.startRmsHoldingLoader();
        this.usecase.rmsHolding.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.rmsDetails.updateRmsHolding(data);
                _this.actions.rmsDetails.stopRmsHoldingLoader();
            },
            onError: function (error) {
                _this.actions.rmsDetails.setError({ isOpen: true, error: error }, IRMSErrorEnum.RMS_HOLDING_ERROR);
                _this.actions.rmsDetails.stopRmsHoldingLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.proceedToAuthorize = function (authorizePayload) {
        var _this = this;
        this.actions.proceedToAuth.hideError();
        this.actions.proceedToAuth.loader();
        this.usecase.authorize.execute({
            onSuccess: function (data) {
                var _a;
                if (data)
                    _this.actions.proceedToAuth.proceedToAuth(data);
                localStorage.setItem("AuthToSellSymbol", (_a = authorizePayload === null || authorizePayload === void 0 ? void 0 : authorizePayload.lst[0]) === null || _a === void 0 ? void 0 : _a.sym);
                _this.actions.proceedToAuth.stopLoader();
            },
            onError: function (error) {
                _this.actions.proceedToAuth.setError({ isOpen: true, error: error });
                _this.actions.proceedToAuth.stopLoader();
            },
        }, authorizePayload);
    };
    TOCJourneyPresenter.prototype.getUPIList = function (req) {
        var _this = this;
        this.actions.upiList.hideError();
        this.actions.upiList.loader();
        this.usecase.upiList.execute({
            onSuccess: function (data) {
                _this.actions.upiList.getUPIList(data);
                _this.actions.upiList.stopLoader();
            },
            onError: function (error) {
                _this.actions.upiList.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.upiList.stopLoader();
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.getSpecificIPODetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.specificIPO.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getSpecificNcdIpoDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.ncdIpoDetail.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getNcdIpoSeries = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.ncdIpoSeries.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.applyIPO = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.applyIPO.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.addClientDetailsNCd = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.addClientDetailsNCd.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getncdipoCheckPincode = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getncdipoCheckPincode.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getIpoValidateUpi = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getIpoValidateUpi.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getUserStatus = function (req) {
        var _this = this;
        this.actions.userStatus.hideError();
        this.actions.userStatus.startLoader();
        this.usecase.getUserStatus.execute({
            onSuccess: function (data) {
                _this.actions.userStatus.stopLoader();
                _this.actions.userStatus.getUserStatus(data);
            },
            onError: function (error) {
                _this.actions.userStatus.stopLoader();
                _this.actions.userStatus.setError({ isOpen: true, error: error });
            },
        }, req);
    };
    TOCJourneyPresenter.prototype.flushUserStatus = function () {
        this.actions.userStatus.flushUserStatus();
    };
    TOCJourneyPresenter.prototype.getAsmGsmStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getAsmGsmStatus.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.exitAllBoOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.exitAllBoOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.multiQuoteStreaming = function (subscribe, symbols) {
        var _this = this;
        var streamKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
            streamKeys[5],
            streamKeys[15],
            streamKeys[16],
        ];
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.actions.multiQuoteActions.getStreamMultiQuote(data);
                return [2 /*return*/];
            });
        }); }, symbols, streamKey, StreamingSectionName.Common_SideBar);
    };
    TOCJourneyPresenter.prototype.getMFSwitchDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFSwitchDetails.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    TOCJourneyPresenter.prototype.getMFSwitchDetailsFilter = function (req, tabsToFilter) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFSwitchDetailsFilter.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, { req: req, tabsToFilter: tabsToFilter });
        });
    };
    TOCJourneyPresenter.prototype.mfModifyOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfModifyOrder.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    return TOCJourneyPresenter;
}());
export default TOCJourneyPresenter;
